import React from 'react';
import { FormFieldBase, FormFieldInput } from '.';
import { getFieldProperties, getFieldPropertyValues } from './helpers';

export const FormFieldGender = ({
  field,
  isRenderedField,
  onChange,
  value,
  onBlur,
  validationMessage,
  readOnly,
}) => {
  // get options from properties
  const properties = getFieldProperties(field, ['common', 'specific']);
  const { options = [] } = getFieldPropertyValues(properties.specific, 'options');

  // if rendering on a published form, add empty placeholder as first option if it doesn't already exist
  if (isRenderedField && options[0][0] !== 'placeholder')
    options.unshift(['placeholder', { value: '', defaultValue: '' }]);

  return (
    <FormFieldInput
      field={field}
      options={{
        properties,
        isRenderedField,
        onChange,
        value,
        onBlur,
        validationMessage,
        readOnly,
      }}
    >
      {isRenderedField &&
        options.map((option, index) => {
          let { value, defaultValue } = option[1];
          value = value || defaultValue;
          return (
            <option key={index} value={value}>
              {value}
            </option>
          );
        })}
    </FormFieldInput>
  );
};

FormFieldGender.defaultProps = {
  isRenderedField: false,
  onChange: () => { },
  value: '',
  onBlur: () => { },
  readOnly: false,
};

export default FormFieldBase(FormFieldGender);
